'use strict';

(function () {

  var CUSTOM_MOUNT_VALUE = 'Custom Mount';

  // Remove the fitment variant lock so the customer can pick any option.
  function unlockFitmentFieldsets() {
    document.querySelectorAll('[data-fitment-locked="true"]').forEach(function (fs) {
      fs.removeAttribute('data-fitment-locked');
      fs.removeAttribute('aria-disabled');
    });
    document.querySelectorAll('[data-fitment-unmatched]').forEach(function (el) {
      el.removeAttribute('data-fitment-unmatched');
    });
  }

  // Select the universal rail (ZTBUNV) variant on the product's variant-selects.
  function selectUniversalVariant() {
    var universalSku = window.YMM_UNIVERSAL_SKU;
    if (!universalSku) return;
    var variantSelects = document.querySelector('variant-selects[data-fitment-messaging="true"]') ||
                         document.querySelector('variant-selects');
    if (!variantSelects) return;
    var variantDataEl = variantSelects.querySelector('[type="application/json"]');
    if (!variantDataEl) return;
    var variants;
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { return; }
    var target = null;
    for (var i = 0; i < variants.length; i++) {
      if ((variants[i].sku || '').toLowerCase() === universalSku.toLowerCase()) {
        target = variants[i];
        break;
      }
    }
    if (!target) return;
    var fieldsets = variantSelects.querySelectorAll('fieldset');
    if (target.options) {
      target.options.forEach(function (optionValue, index) {
        var fieldset = fieldsets[index];
        if (!fieldset) return;
        var radio = fieldset.querySelector('input[type="radio"][value="' + String(optionValue).replace(/"/g, '\\"') + '"]');
        if (radio) {
          radio.checked = true;
        } else {
          var sel = fieldset.querySelector('select');
          if (sel) sel.value = optionValue;
        }
      });
      variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Sync the fitment line-item hidden inputs for the non-AJAX submit path.
  function syncFitmentProps(isCustomMount) {
    var skuInput    = document.getElementById('fitment-prop-sku');
    var statusInput = document.getElementById('fitment-prop-fitment-status');
    if (isCustomMount) {
      if (skuInput && window.YMM_UNIVERSAL_SKU) skuInput.value = window.YMM_UNIVERSAL_SKU;
      if (statusInput) statusInput.value = 'Pending Review';
    } else {
      // Restore the selected vehicle's fitment SKU (if any) when leaving Custom Mount.
      var vehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;
      var storedFitment = vehicle && vehicle.fitment ? vehicle.fitment : null;
      if (skuInput) skuInput.value = storedFitment ? (storedFitment.sku || '') : '';
      if (statusInput) statusInput.value = '';
    }
  }

  function initToolboxLogic() {
    var mountTypeHidden = document.getElementById('toolbox-mount-type');
    var toolboxFields   = document.getElementById('toolbox-fields');
    var toolboxBanner   = document.getElementById('fitment-banner-toolbox');
    var toolboxReviewFlag = document.getElementById('toolbox-review-flag');
    var mountOptions    = document.querySelectorAll('.fitment-mount-type__option');

    if (!mountTypeHidden || !toolboxFields || !mountOptions.length) return;

    var _savedNames = {};

    function stripNames() {
      toolboxFields.querySelectorAll('input[name^="properties"], textarea[name^="properties"]').forEach(function (el) {
        _savedNames[el.id || el.name] = el.getAttribute('name');
        el.removeAttribute('name');
      });
    }

    function restoreNames() {
      toolboxFields.querySelectorAll('input, textarea').forEach(function (el) {
        var key = el.id || el.name;
        if (key && _savedNames[key]) {
          el.setAttribute('name', _savedNames[key]);
        }
      });
    }

    function syncRequiredAttrs(enabled) {
      toolboxFields.querySelectorAll('input[data-required="true"], textarea[data-required="true"]').forEach(function (el) {
        if (enabled) {
          el.setAttribute('required', '');
          el.setAttribute('aria-required', 'true');
        } else {
          el.removeAttribute('required');
          el.removeAttribute('aria-required');
        }
      });
      if (!enabled) {
        toolboxFields.querySelectorAll('input, textarea').forEach(function (el) {
          el.value = '';
        });
      }
    }

    function applySelection(selectedValue) {
      mountTypeHidden.value = selectedValue;
      mountOptions.forEach(function (opt) {
        opt.classList.toggle('fitment-mount-type__option--selected', opt.dataset.mountValue === selectedValue);
      });
      var isCustomMount = selectedValue === CUSTOM_MOUNT_VALUE;
      if (toolboxReviewFlag) toolboxReviewFlag.value = isCustomMount ? 'true' : 'false';
      if (isCustomMount) {
        toolboxFields.classList.add('visible');
        restoreNames();
        syncRequiredAttrs(true);
        if (toolboxBanner) { toolboxBanner.removeAttribute('hidden'); toolboxBanner.classList.add('visible'); }
        // Custom mount overrides the fitment lock and resolves to the universal rail SKU.
        unlockFitmentFieldsets();
        selectUniversalVariant();
      } else {
        toolboxFields.classList.remove('visible');
        syncRequiredAttrs(false);
        stripNames();
        if (toolboxBanner) { toolboxBanner.setAttribute('hidden', ''); toolboxBanner.classList.remove('visible'); }
        // Restore the vehicle-based fitment lock if a vehicle is selected.
        if (window.FitmentFilter && window.FitmentFilter.applyVariantLock) {
          window.FitmentFilter.applyVariantLock();
        }
      }
      syncFitmentProps(isCustomMount);
      document.dispatchEvent(new CustomEvent('ymm:mount-changed', { detail: { custom: isCustomMount } }));
    }

    mountOptions.forEach(function (opt) {
      opt.addEventListener('click', function () {
        applySelection(opt.dataset.mountValue);
      });
    });

    // Initial state: if Truck Bed is default, strip names immediately
    var defaultValue = mountTypeHidden.value;
    if (defaultValue !== CUSTOM_MOUNT_VALUE) {
      syncRequiredAttrs(false);
      stripNames();
    }
    document.dispatchEvent(new CustomEvent('ymm:mount-changed', { detail: { custom: defaultValue === CUSTOM_MOUNT_VALUE } }));
  }

  document.addEventListener('DOMContentLoaded', initToolboxLogic);
  document.addEventListener('quick-view:open', initToolboxLogic);

})();
